"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTableWidth = void 0;
var enums_1 = require("../../enums");
function GetTableWidth(headers) {
    var width = 0;
    headers.forEach(function (element) {
        if (element.id === "actions") {
            width += 20;
        }
        else {
            switch (element.columnWidthSize) {
                case enums_1.UiSizes.LG:
                    width += 350;
                    break;
                case enums_1.UiSizes.MD:
                    width += 300;
                    break;
                case enums_1.UiSizes.SM:
                    width += 250;
                    break;
                case enums_1.UiSizes.XS:
                    width += 150;
                    break;
                case enums_1.UiSizes.XXS:
                    width += 100;
                    break;
                default:
                    width += 100;
                    break;
            }
        }
    });
    return width;
}
exports.GetTableWidth = GetTableWidth;
